import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getDealers = (filters, token) =>
    axios({
        method: 'get',
        url: `${api}/dealers?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
        }
    });

export const postDealers = (dealer, token) =>
    axios({
        method: 'post',
        url: `${api}/dealers`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/dealers`
        },
        data: dealer
    });

export const putDealers = (dealer, token) =>
    axios({
        method: 'put',
        url: `${api}/dealers/${dealer.identifier}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/dealers`
        },
        data: dealer
    });

export const deleteDealers = (dealer, token) =>
    axios({
        method: 'delete',
        url: `${api}/dealers/${dealer.identifier}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            expireResponseWithKey: `${api}/dealers`
        }
    });
